import errorMappings from '~/assets/data/error-mappings.json';
import DisclosureFooter from '~/components/members-area/DisclosureFooter.vue';
export default {
  name: 'FunnelError',
  components: {
    DisclosureFooter
  },
  props: {
    errorContext: {
      type: Object
    },
    canRetryPlaid: {
      type: Boolean,
      required: true
    },
    isDev: {
      type: Boolean,
      required: false
    }
  },
  emits: ['resetPlaid', 'clearError', 'retryPersona'],
  data() {
    var _this$errorContext;
    return {
      errorMessaging: errorMappings[(_this$errorContext = this.errorContext) === null || _this$errorContext === void 0 ? void 0 : _this$errorContext.context],
      buttonClasses: 'button--white first:button--filled shrink-0 h-12 sm:w-full',
      policiesButton: false,
      devOnlyButton: false,
      tryAgainButton: false,
      resetPlaidButton: false,
      newBankButton: false,
      retryPersonaButton: false,
      loginButton: false
    };
  },
  computed: {
    errorBody() {
      var _this$errorMessaging;
      return (_this$errorMessaging = this.errorMessaging) === null || _this$errorMessaging === void 0 ? void 0 : _this$errorMessaging.body;
    }
  },
  mounted() {
    var _this$errorContext2, _this$errorMessaging$;
    this.$analyticsHub.track(`Error.funnel.${(_this$errorContext2 = this.errorContext) === null || _this$errorContext2 === void 0 ? void 0 : _this$errorContext2.context}`);
    if (!this.errorMessaging) {
      var _this$errorContext3, _this$errorContext4, _this$errorContext5, _this$errorContext6;
      // sort plaid error contexts into generic buckets (new bank, try again etc)
      if (['INVALID_ACCESS_TOKEN', 'ITEM_NOT_FOUND', 'ITEM_LOGIN_REQUIRED', 'INSUFFICIENT_CREDENTIALS', 'INVALID_FIELD', 'INVALID_CREDENTIALS', 'INVALID_MFA', 'INVALID_LINK_TOKEN', 'shouldRelinkPlaid', 'finishPlaidHealthError'].includes((_this$errorContext3 = this.errorContext) === null || _this$errorContext3 === void 0 ? void 0 : _this$errorContext3.context)) {
        this.errorMessaging = errorMappings.loginToPlaid; // Apologies, we seem to be having some trouble; relink Plaid
      } else if (['PRODUCT_NOT_READY', 'INSTITUTION_NOT_RESPONDING', 'RATE_LIMIT', 'INTERNAL_SERVER_ERROR'].includes((_this$errorContext4 = this.errorContext) === null || _this$errorContext4 === void 0 ? void 0 : _this$errorContext4.context)) {
        this.errorMessaging = errorMappings.plaidProductNotReady; // this is taking longer than usual
      } else if (['NO_ACCOUNTS', 'NO_AUTH_ACCOUNTS', 'plaidUnsupported'].includes((_this$errorContext5 = this.errorContext) === null || _this$errorContext5 === void 0 ? void 0 : _this$errorContext5.context)) {
        this.errorMessaging = errorMappings.plaidUnsupported; // not compatible, try a different bank
      } else if (['ACCESS_NOT_GRANTED', 'ITEM_LOCKED'].includes((_this$errorContext6 = this.errorContext) === null || _this$errorContext6 === void 0 ? void 0 : _this$errorContext6.context)) {
        this.errorMessaging = errorMappings.plaidAccessNotGranted; // may be due to permissions, try a different bank
      } else {
        this.errorMessaging = errorMappings.allOthers;
      }
    }

    // setup default/fallback error context if one does not exist
    const errorContext = this.errorContext || {};
    if (!errorContext.context) {
      errorContext.context = 'unknown';
    }

    // Add datadog log for errors
    // differentiate slightly for allOthers marked errors
    if (this.errorMessaging === errorMappings.allOthers) {
      this.$ddLogs.logger.error('[funnel][error] other bucket error occurred', errorContext);
    } else {
      this.$ddLogs.logger.warn(`[funnel][error] ${errorContext.context} error occurred`, errorContext);
    }
    (_this$errorMessaging$ = this.errorMessaging.buttons) === null || _this$errorMessaging$ === void 0 || _this$errorMessaging$.forEach(button => {
      switch (button) {
        // concierge button has been removed
        case 'proceed_to_policies':
          this.policiesButton = true;
          break;
        case 'dev_only_retry':
          this.devOnlyButton = true;
          break;
        case 'try_again':
          this.tryAgainButton = true;
          break;
        case 'reset_plaid':
          this.resetPlaidButton = true;
          break;
        case 'new_bank':
          this.newBankButton = true;
          break;
        case 'retry_persona':
          this.retryPersonaButton = true;
          break;
        case 'login':
          this.loginButton = true;
          break;
        default:
          console.warn('Are you missing a button?', button);
      }
    });
  }
};